import { HomePage } from "./pages/home";
import Header from "./components/header/header";
import { WhatsAppButton } from "./components/whatsapp-button";
import { ThemeProvider } from "./context/theme-context";
import "./index.css";

export function App() {
  return (
    <ThemeProvider>
      <div className="min-h-screen bg-[#F4F7FB] dark:bg-[#09090C]">
        <Header />
        <HomePage />
        <WhatsAppButton />
      </div>
    </ThemeProvider>
  );
}

export default App;
